<template>
  <div class="full_height">
    <div class="full_height" v-if="isToken">
      <el-row class="full_height" v-if="!isMobilePhone">
        <el-col class="full_height left" :style="{ width: leftWidth }">
          <!-- <el-col
        class="full_height left"
        :style="{'width':leftWidth}"
        :class="{'isCollapseLeft':collapseStatus}"
          >-->
          <!-- <el-col
        class="full_height left"
        :style="{'width':leftWidth}"
        :class="{'isCollapseLeft':collapseStatus}"
          >-->
          <!-- <span
          :class="!collapseStatus?'data-isCollapse':'data-isCollapseoff'"
          @click="collapse"
          class="collapse_btn"
          ></span>-->
          <data-left></data-left>
        </el-col>
        <el-col class="full_height toopTip" :style="{ width: rightWidth }">
          <div class="route_right" id="route_right">
            <router-view></router-view>
          </div>
          <div class="home-page toopTip" v-if="showIndex">
            <home-page></home-page>
          </div>
        </el-col>
      </el-row>
      <!-- 移动端 -->
      <div v-else class="full_height">
        <!-- 为了保存左侧状态 以及右侧状态重置  采用左侧v-show  右侧v-if -->
        <data-left-mobile
          @changRightStatus="changRightStatus"
          v-show="showLeft"
        ></data-left-mobile>
        <data-right-mobile
          v-if="!showLeft"
          :com="currentRight"
          :conditions="conditions"
          @changeLeftStatus="changeLeftStatus"
        ></data-right-mobile>
      </div>
    </div>
  </div>
</template>

<script>
import DataLeft from "./components/DataLeft";
import DataLeftMobile from "./components/mobile/DataLeft";
import DataRightMobile from "./components/mobile/DataRight";
import HomePage from "./components/homePage/index";
import { mapState, mapMutations,mapGetters } from "vuex";
import {
  getAllPermission,
  getAllPermissionNew,
  testPer,
} from "common/js/http/v2Api";

const keyMap = {
  Industry: "INDUSTRY_DETAIL",
  Macro: "MACRO_DETAIL",
  Company: "COMPANY_DETAIL",
  Transaction: "CMTRANS_DETAIL",
};

export default {
  name: "SearchContainer",

  components: { DataLeft, DataLeftMobile, DataRightMobile, HomePage },

  data() {
    return {
      leftWidth: "33%",
      rightWidth: "66%",
      // isCollapse: false,
      isMobilePhone: false,
      showLeft: true,
      currentRight: "Company",
      conditions: null,
      isToken: null,
      userName: this.Cookies.get("imsilkroad_username"),
      userId: parseInt(this.Cookies.get("imsilkroad_userid")),
    };
  },

  mounted() {
    this.isMobile();
    let that = this;
    this.$axios.post("/api/pc/getmember").then(
      function (data) {
        console.log(data.data.data, "pi/pc/getmembe");
        if (data.data.state) {
          that.$store.commit("userInfo", data.data.data);
          console.log(that.collapseStatus);
          console.log(that.userInfo,'userInfo');
          if (that.userInfo.group_id) {
            that.getPermission();
          } else {
            that.$eventBus.$on("userInfoUpdate", (data) => {
              that.getPermission();
            });
          }
        } else {
        }
      },
      function (response) {
        console.info(response);
        if (response) {
          console.log("失败");
        }
      }
    );
    //
    // this.getAllPermissionTest();
  },

  methods: {
    // collapse() {
    //   this.isCollapse = !this.isCollapse;
    //   if (this.isCollapse) {
    //     this.leftWidth = "0%";
    //     this.rightWidth = "100%";
    //   } else {
    //     this.leftWidth = "33%";
    //     this.rightWidth = "66%";
    //   }
    //   this.setCollapse(this.isCollapse);
    // },
    async getPermission() {
      const params = {
        // id: 3091,
        // type: 0,
        // userName: "imtest"
        id: this.userId,
        type: 0,
        userName: this.userName,
        status: 1, //权限状态，默认下线的权限也会返回.0:下线,1:在线状态
        groupId: this.userInfo.group_id,
        email: this.userInfo.email,
        phone: this.userInfo.mobile
      };
      const { data: result } = await getAllPermissionNew(params);
      console.log(result, "getAllPermissionNew");
      //账户被锁定
      if (!result.status) {
        // 0 冻结 1正常
        this.$message({
          message:
            "Your account has been locked, please contact the administrator!",
          type: "error",
          duration: 0,
        });
        return;
      }

      this.Cookies.set("v2Token", result.token);
      const allowPerKey = result.permissions.map((item) => item.value);
      console.log(allowPerKey,'allowPerKey-allowPerKey');
      this.setV2CurrentPermission(allowPerKey);
      this.setV2CountryList(result.countrys);
      // alert(result.token)
      //没有登录页面,所以必须阻塞页面加载 等到init 返回token 在向下加载
      this.isToken = true;
      console.log("tets");
    },
    async getPermissionOld() {
      const params = {
        // id: 3091,
        // type: 0,
        // userName: "imtest"
        id: this.userId,
        type: 0,
        userName: this.userName,
      };
      const { result } = await getAllPermission(params);

      //账户被锁定
      if (!result.userInfo.status) {
        this.$message({
          message:
            "Your account has been locked, please contact the administrator!",
          type: "error",
          duration: 0,
        });
        return;
      }

      this.Cookies.set("v2Token", result.token);
      const allowPerKey = result.permissions.map((item) => item.tagCode);

      this.setV2CurrentPermission(allowPerKey);
      this.setV2CountryList(result.countries);
      // alert(result.token)
      //没有登录页面,所以必须阻塞页面加载 等到init 返回token 在向下加载
      this.isToken = true;
      console.log("tets");
    },

    getAllPermissionTest() {
      this.isToken = true;
      const permissionsTest = [
        {
          tagCode: "INDUSTRY_DETAIL",
          tag: "行业数据",
          type: false,
          url: "",
          status: true,
        },
        {
          tagCode: "MACRO_DETAIL",
          tag: "宏观数据",
          type: false,
          url: "",
          status: true,
        },
        {
          tagCode: "CMTRANS_DOWNLOAD",
          tag: "并购数据下载",
          type: false,
          url: "",
          status: true,
        },
        {
          tagCode: "MACRO_DOWNLOAD",
          tag: "宏观数据下载",
          type: false,
          url: "",
          status: true,
        },
        {
          tagCode: "CMTRANS_DETAIL",
          tag: "并购数据",
          type: false,
          url: "",
          status: true,
        },
        {
          tagCode: "COMPANY_DOWNLOAD",
          tag: "企业数据下载",
          type: false,
          url: "",
          status: true,
        },
        {
          tagCode: "INDUSTRY_DOWNLOAD",
          tag: "行业数据下载",
          type: false,
          url: "",
          status: true,
        },
        {
          tagCode: "COMPANY_DETAIL",
          tag: "企业数据",
          type: false,
          url: "",
          status: true,
        },
        {
          tagCode: "CUSTEEL_DATA",
          tag: "钢铁行业数据",
          type: false,
          url: "",
          status: true,
        },
        {
          tagCode: "FOODSTUFF_DATA",
          tag: "食品与土特产数据",
          type: false,
          url: "",
          status: true,
        },
        {
          tagCode: "AGRICULTURAL_DATA",
          tag: "农产品数据",
          type: false,
          url: "",
          status: true,
        },
      ];

      // const token = `eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIxIiwiaWF0IjoxNTg1MTE4MjM5LCJzdWIiOiJzaWxrLXJvYWQtZW4iLCJpc3MiOiJ0ZXN0IiwiZXhwIjoxNTg1MTI1NDM5fQ.vLzDz0xTNIaWjdrD92MMcBxXWza8jrggfKP7-qk3esg`;
      // this.Cookies.set("v2Token", token);
      const allowPerKey = permissionsTest.map((item) => item.tagCode);
      // console.log("getPermission -> county1", county)
      const county = [
        {
          id: 2,
          cnName: "欧洲",
          enName: "Europe",
          code: "",
          children: [
            {
              code: "ALB",
              cnName: "china",
              macroEnName: "CHINA",
              enName: "Albania",
              macroEnFullName: "CHINA",
              id: 8,
            },
            {
              code: "ALB",
              cnName: "阿尔巴尼亚",
              macroEnName: "ALBANIA",
              enName: "Albania",
              macroEnFullName: "REPUBLIC OF ALBANIA",
              id: 8,
            },
            {
              code: "IRL",
              cnName: "爱尔兰",
              macroEnName: "IRELAND",
              enName: "Ireland",
              macroEnFullName: "IRELAND",
              id: 19,
            },
            {
              code: "EST",
              cnName: "爱沙尼亚",
              macroEnName: "ESTONIA",
              enName: "Estonia",
              macroEnFullName: "REPUBLIC OF ESTONIA",
              id: 20,
            },
            {
              code: "AND",
              cnName: "安道尔",
              macroEnName: "ANDORRA",
              enName: "Andorra",
              macroEnFullName: "PRINCIPALITY OF ANDORRA",
              id: 21,
            },
            {
              code: "AUT",
              cnName: "奥地利",
              macroEnName: "AUSTRIA",
              enName: "Austria",
              macroEnFullName: "REPUBLIC OF AUSTRIA",
              id: 26,
            },
            {
              code: "ALA",
              cnName: "奥兰群岛",
              macroEnName: "ALAND ISLAND",
              enName: "Aland lslands",
              macroEnFullName: "ALAND ISLAND",
              id: 27,
            },
            {
              code: "BLR",
              cnName: "白俄罗斯",
              macroEnName: "BELARUS",
              enName: "White Russia",
              macroEnFullName: "REPUBLIC OF BELARUS",
              id: 37,
            },
            {
              code: "BGR",
              cnName: "保加利亚",
              macroEnName: "BULGARIA",
              enName: "Bulgaria",
              macroEnFullName: "REPUBLIC OV BULGARIA",
              id: 39,
            },
            {
              code: "BEL",
              cnName: "比利时",
              macroEnName: "BELGIUM",
              enName: "Belgium",
              macroEnFullName: "KINGDOM OF BELGIUM",
              id: 42,
            },
            {
              code: "ISL",
              cnName: "冰岛",
              macroEnName: "ICELAND",
              enName: "Iceland",
              macroEnFullName: "REPUBLIC OF ICELAND",
              id: 43,
            },
            {
              code: "POL",
              cnName: "波兰",
              macroEnName: "POLAND",
              enName: "Poland",
              macroEnFullName: "REPUBLIC OF POLAND",
              id: 45,
            },
            {
              code: "BIH",
              cnName: "波斯尼亚和黑塞哥维那",
              macroEnName: "BOSNIA AND HERZEGOVINA",
              enName: "Bosnia and Herzegovina",
              macroEnFullName: "REPUBLIC OF BOSNIA AND HERZEGOVINA",
              id: 47,
            },
            {
              code: "BVT",
              cnName: "布韦岛",
              macroEnName: "ZIMBABWE",
              enName: "Bouvet Island",
              macroEnFullName: "REPUBLIC OF ZIMBABWE",
              id: 53,
            },
            {
              code: "DNK",
              cnName: "丹麦",
              macroEnName: "DENMARK",
              enName: "Denmark",
              macroEnFullName: "KINGDOM OF DENMARK",
              id: 55,
            },
            {
              code: "DEU",
              cnName: "德国",
              macroEnName: "GERMANY",
              enName: "Germany",
              macroEnFullName: "FEDERAL REPUBLIC OF GERMANY",
              id: 56,
            },
            {
              code: "RUS",
              cnName: "俄罗斯",
              macroEnName: "RUSSIA",
              enName: "Russia",
              macroEnFullName: "RUSSIAN FEDERATION",
              id: 61,
            },
            {
              code: "FRA",
              cnName: "法国",
              macroEnName: "FRANCE",
              enName: "France",
              macroEnFullName: "FRENCH REPUBLIC",
              id: 64,
            },
            {
              code: "FRO",
              cnName: "法罗群岛",
              macroEnName: "FAROE ISLANDS",
              enName: "Faroe Islands",
              macroEnFullName: "FAROE ISLANDS",
              id: 65,
            },
            {
              code: "ATF",
              cnName: "法属南部领地",
              macroEnName: "FRENCH SOUTHERN TERRITO-RIES",
              enName: "French Southern and Antarctic Lands",
              macroEnFullName: "FRENCH SOUTHERN TERRITORIES",
              id: 68,
            },
            {
              code: "VAT",
              cnName: "梵蒂冈",
              macroEnName: "VATICAN",
              enName: "Vatican City",
              macroEnFullName: "VATICAN CITY STATE",
              id: 69,
            },
            {
              code: "FIN",
              cnName: "芬兰",
              macroEnName: "FINLAND",
              enName: "Finland",
              macroEnFullName: "REPUBLIC OF FINLAND",
              id: 72,
            },
            {
              code: "FLK",
              cnName: "弗兰克群岛",
              enName: "Falkland Islands",
              id: 74,
            },
            {
              code: "GGY",
              cnName: "格恩西岛",
              macroEnName: "GUERNSEY",
              enName: "Guernsey",
              macroEnFullName: "GUERNSEY",
              id: 80,
            },
            {
              code: "NLD",
              cnName: "荷兰",
              macroEnName: "NETHERLANDS",
              enName: "Netherlands",
              macroEnFullName: "KINGDOM OF THE NETHERLANDS",
              id: 90,
            },
            {
              code: "CZE",
              cnName: "捷克共和国",
              macroEnName: "CZECH REPUBLIC",
              enName: "Czech Republic",
              macroEnFullName: "CZECH REPUBLIC",
              id: 103,
            },
            {
              code: "HRV",
              cnName: "克罗地亚",
              macroEnName: "CROATIA",
              enName: "Croatia",
              macroEnFullName: "REPUBLIC OF CROATIA",
              id: 112,
            },
            {
              code: "LVA",
              cnName: "拉脱维亚",
              macroEnName: "LATVIA",
              enName: "Latvia",
              macroEnFullName: "REPUBLIC OF LATVIA",
              id: 115,
            },
            {
              code: "LTU",
              cnName: "立陶宛",
              macroEnName: "LITHUANIA",
              enName: "Lithuania",
              macroEnFullName: "REPUBLIC OF LITHUANIA",
              id: 121,
            },
            {
              code: "LIE",
              cnName: "列支敦士登",
              macroEnName: "LIECHTENSTEIN",
              enName: "Liechtenstein",
              macroEnFullName: "PRINCIPALITY OF LIECHTENSTEIN",
              id: 122,
            },
            {
              code: "REU",
              cnName: "留尼旺岛",
              macroEnName: "REUNION",
              enName: "Reunion",
              macroEnFullName: "REUNION",
              id: 123,
            },
            {
              code: "LUX",
              cnName: "卢森堡",
              macroEnName: "LUXEMBOURG",
              enName: "Luxembourg",
              macroEnFullName: "GRAND DUCHY OF LUXEMBOURG",
              id: 124,
            },
            {
              code: "ROU",
              cnName: "罗马尼亚",
              macroEnName: "ROMANIA",
              enName: "Romania",
              macroEnFullName: "ROMANIA",
              id: 126,
            },
            {
              code: "MLT",
              cnName: "马耳他",
              macroEnName: "MALTA",
              enName: "Malta",
              macroEnFullName: "REPUBLIC OF MALTA",
              id: 129,
            },
            {
              code: "MKD",
              cnName: "马其顿",
              macroEnName: "MACEDONIA",
              enName: "Macedonia,Former Yugoslav Republic of",
              macroEnFullName: "REPUBLIC OF MACEDONIA",
              id: 133,
            },
            {
              code: "IMN",
              cnName: "曼岛",
              macroEnName: "ISLE OF MAN",
              enName: "Isle of Man",
              macroEnFullName: "ISLE OF MAN",
              id: 137,
            },
            {
              code: "MDA",
              cnName: "摩尔多瓦",
              macroEnName: "MOLDOVA",
              enName: "Moldova",
              macroEnFullName: "REPUBLIC OF MOLDOVA",
              id: 149,
            },
            {
              code: "MCO",
              cnName: "摩纳哥",
              macroEnName: "MONACO",
              enName: "Monaco",
              macroEnFullName: "PRINCIPALITY OF MONACO",
              id: 151,
            },
            {
              code: "NOR",
              cnName: "挪威",
              macroEnName: "NORWAY",
              enName: "Norway",
              macroEnFullName: "KINGDOM OF NORWAY",
              id: 164,
            },
            {
              code: "PRT",
              cnName: "葡萄牙",
              macroEnName: "PORTUGAL",
              enName: "Portugal",
              macroEnFullName: "PIRTUGUESE REPUBLIC",
              id: 168,
            },
            {
              code: "SWE",
              cnName: "瑞典",
              macroEnName: "SWEDEN",
              enName: "Sweden",
              macroEnFullName: "KINGDOM OF SWEDEN",
              id: 171,
            },
            {
              code: "CHE",
              cnName: "瑞士",
              macroEnName: "SWITZERLAND",
              enName: "Switzerland",
              macroEnFullName: "SWISS CONFEDERATION",
              id: 172,
            },
            {
              code: "SCG",
              cnName: "塞尔维亚,黑山",
              macroEnName: "MONTENEGRO",
              enName: "Serbia,Montenegro",
              macroEnFullName: "REPUBLIC OF MONTENEGRO",
              id: 175,
            },
            {
              code: "SMR",
              cnName: "圣马力诺",
              macroEnName: "SAN MARINO",
              enName: "San Marino",
              macroEnFullName: "REPUBLIC OF SAN MARINO",
              id: 186,
            },
            {
              code: "SVK",
              cnName: "斯洛伐克",
              macroEnName: "SLOVAKIA",
              enName: "Slovakia",
              macroEnFullName: "SLOVAK REPUBLIC",
              id: 190,
            },
            {
              code: "SVN",
              cnName: "斯洛文尼亚",
              macroEnName: "SLOVENIA",
              enName: "Slovenia",
              macroEnFullName: "REPUBLIC OF SLOVENIA",
              id: 191,
            },
            {
              code: "SJM",
              cnName: "斯瓦尔巴和扬马廷",
              macroEnName: "SVALBARD AND JAN MAYEN ISLANDS",
              enName: "Svalbard and Jan Mayen",
              macroEnFullName: "SVALBARD AND JAN MAYEN ISLANDS",
              id: 192,
            },
            {
              code: "UKR",
              cnName: "乌克兰",
              macroEnName: "UKRAINE",
              enName: "Ukraine",
              macroEnFullName: "UKRAINE",
              id: 218,
            },
            {
              code: "ESP",
              cnName: "西班牙",
              macroEnName: "SPAIN",
              enName: "Spain",
              macroEnFullName: "SPAIN",
              id: 221,
            },
            {
              code: "GRC",
              cnName: "希腊",
              macroEnName: "GREECE",
              enName: "Greece",
              macroEnFullName: "HELLENIC REPUBLIC",
              id: 222,
            },
            {
              code: "HUN",
              cnName: "匈牙利",
              macroEnName: "HUNGARY",
              enName: "Hungary",
              macroEnFullName: "REPUBLIC OF HUNGARY",
              id: 226,
            },
            {
              code: "ITA",
              cnName: "意大利",
              macroEnName: "ITALY",
              enName: "Italy",
              macroEnFullName: "REPUBLIC OF ITALY",
              id: 234,
            },
            {
              code: "GBR",
              cnName: "英国",
              macroEnName: "UNITED KINGDOM",
              enName: "United Kingdom",
              macroEnFullName: "UNITED KINGDOM OF GREAT BRITAIN AND",
              id: 237,
            },
            {
              code: "JEY",
              cnName: "泽西岛",
              macroEnName: "JERSEY",
              enName: "Jersey",
              macroEnFullName: "JERSEY",
              id: 242,
            },
          ],
        },
        {
          id: 5,
          cnName: "南美",
          enName: "South America",
          code: "",
          children: [
            {
              code: "ARG",
              cnName: "阿根廷",
              macroEnName: "ARGENTINA",
              enName: "Argentina",
              macroEnFullName: "REPUBLIC OF ARGENTINA",
              id: 11,
            },
            {
              code: "ABW",
              cnName: "阿鲁巴",
              macroEnName: "ARUBA",
              enName: "Aruba",
              macroEnFullName: "ARUBA",
              id: 13,
            },
            {
              code: "AIA",
              cnName: "安圭拉",
              macroEnName: "ANGUILLA",
              enName: "Anguilla",
              macroEnFullName: "ANGUILLA",
              id: 23,
            },
            {
              code: "BRB",
              cnName: "巴巴多斯岛",
              macroEnName: "BARBADOS",
              enName: "Barbados",
              macroEnFullName: "BARBADOS",
              id: 28,
            },
            {
              code: "PRY",
              cnName: "巴拉圭",
              macroEnName: "PARAGUAY",
              enName: "Paraguay",
              macroEnFullName: "REPUBLIC OF PARAGUAY",
              id: 32,
            },
            {
              code: "BRA",
              cnName: "巴西",
              macroEnName: "BRAZIL",
              enName: "Brazil",
              macroEnFullName: "FEDERATIVE REPUBLIC OF BRAZIL",
              id: 36,
            },
            {
              code: "BOL",
              cnName: "玻利维亚",
              macroEnName: "BOLIVIA",
              enName: "Bolivia",
              macroEnFullName: "REPUBLIC OF BOLIVIA",
              id: 46,
            },
            {
              code: "ECU",
              cnName: "厄瓜多尔",
              macroEnName: "ECUADOR",
              enName: "Ecuador",
              macroEnFullName: "REPUBLIC OF ECUADOR",
              id: 62,
            },
            {
              code: "GUF",
              cnName: "法属圭亚那",
              macroEnName: "FRENCH GUIANA",
              enName: "French Guiana",
              macroEnFullName: "FRENCH GUIANA",
              id: 67,
            },
            {
              code: "COL",
              cnName: "哥伦比亚",
              macroEnName: "COLOMBIA",
              enName: "Colombia",
              macroEnFullName: "REPUBLIC OF COLOMBIA",
              id: 78,
            },
            {
              code: "GUY",
              cnName: "圭亚那",
              macroEnName: "GUYANA",
              enName: "Guyana",
              macroEnFullName: "COOPERATIVE REPUBLIC OF GUYANA",
              id: 86,
            },
            {
              code: "ANT",
              cnName: "荷属安地列斯",
              enName: "Netherlands Antilles",
              id: 91,
            },
            {
              code: "PER",
              cnName: "秘鲁",
              macroEnName: "PERU",
              enName: "Peru",
              macroEnFullName: "REPUBLIC OF PERU",
              id: 147,
            },
            {
              code: "SUR",
              cnName: "苏里南",
              macroEnName: "SURINAME",
              enName: "Suriname",
              macroEnFullName: "REPUBLIC OF SURINAME",
              id: 195,
            },
            {
              code: "TAA",
              cnName: "特里斯坦达昆哈",
              enName: "Tristan da Cunha",
              id: 203,
            },
            {
              code: "VEN",
              cnName: "委内瑞拉",
              macroEnName: "VENEZUELA",
              enName: "Venezuela",
              macroEnFullName: "REPUBLIC OF VENEZUELA",
              id: 215,
            },
            {
              code: "URY",
              cnName: "乌拉圭",
              macroEnName: "URUGUAY",
              enName: "Uruguay",
              macroEnFullName: "ORIENTAL REPUBLIC OF URUGUAY",
              id: 219,
            },
            {
              code: "CHL",
              cnName: "智利",
              macroEnName: "CHILE",
              enName: "Chile",
              macroEnFullName: "REPUBLIC OF CHILE",
              id: 245,
            },
          ],
        },
        {
          id: 6,
          cnName: "大洋洲",
          enName: "Oceania",
          code: "",
          children: [
            {
              code: "AUS",
              cnName: "澳大利亚",
              macroEnName: "AUSTRALIA",
              enName: "Australia",
              macroEnFullName: "COMMONWEALTH OF AUSTRALIA",
              id: 25,
            },
            {
              code: "PNG",
              cnName: "巴布亚新几内亚",
              macroEnName: "PAPUA NEW GUINEA",
              enName: "Papua New Guinea",
              macroEnFullName: "INDEPENDENT STATE OF PAPUA NEW GUINEA",
              id: 29,
            },
            {
              code: "PYF",
              cnName: "法属波利尼西亚",
              macroEnName: "FRENCH POLYNESIA",
              enName: "Frech Polynesia",
              macroEnFullName: "FRENCH POLYNESIA",
              id: 66,
            },
            {
              code: "FJI",
              cnName: "斐济",
              macroEnName: "FIJI",
              enName: "Fiji Islands",
              macroEnFullName: "REPUBLIC OF FIJI",
              id: 71,
            },
            {
              code: "GUM",
              cnName: "关岛",
              macroEnName: "GUAM",
              enName: "Guam",
              macroEnFullName: "GUAM",
              id: 85,
            },
            {
              code: "HMD",
              cnName: "赫德和麦克唐纳群岛",
              macroEnName: "HEARD ISLANDS AND MC DONALD ISLANDS",
              enName: "Heard Island and McDonald Islands",
              macroEnFullName: "HEARD ISLANDS AND MC DONALD ISLANDS",
              id: 92,
            },
            {
              code: "KIR",
              cnName: "基里巴斯",
              macroEnName: "KIRIBATI",
              enName: "Kiribati",
              macroEnFullName: "REPUBLIC OF KIRIBATI",
              id: 94,
            },
            {
              code: "CCK",
              cnName: "科科斯群岛",
              macroEnName: "COCOS(KEELING) ISLANDS",
              enName: "Cocos(Keeling)Islands",
              macroEnFullName: "COCOS(KEELING) ISLANDS",
              id: 108,
            },
            {
              code: "COK",
              cnName: "库克群岛",
              macroEnName: "COOK ISLANDS",
              enName: "Cook Islands",
              macroEnFullName: "COOK ISLANDS",
              id: 114,
            },
            {
              code: "MHL",
              cnName: "马绍尔群岛",
              macroEnName: "MARSHALL ISLANDS",
              enName: "Marshall Islands",
              macroEnFullName: "REPUBLIC OF THE MARSHALL ISLANDS",
              id: 134,
            },
            {
              code: "ASM",
              cnName: "美属萨摩亚",
              macroEnName: "AMERICAN SAMOA",
              enName: "American Samoa",
              macroEnFullName: "AMERICAN SAMOA",
              id: 141,
            },
            {
              code: "FSM",
              cnName: "密克罗尼西亚",
              macroEnName: "MICRONESIA",
              enName: "Micronesia",
              macroEnFullName: "FEDERATED STATES OF MICRONESIA",
              id: 146,
            },
            {
              code: "NRU",
              cnName: "瑙鲁",
              macroEnName: "NAURU",
              enName: "Nauru",
              macroEnFullName: "REPUBLIC OF NAURU",
              id: 158,
            },
            {
              code: "NIU",
              cnName: "纽埃",
              macroEnName: "NIUE",
              enName: "Niue",
              macroEnFullName: "NIUE",
              id: 163,
            },
            {
              code: "PLW",
              cnName: "帕劳群岛",
              macroEnName: "PALAU",
              enName: "Palau",
              macroEnFullName: "REPUBLIC OF PALAU",
              id: 166,
            },
            {
              code: "PCN",
              cnName: "皮特凯恩",
              macroEnName: "PITCAIRN ISLANDS GROUP",
              enName: "Pitcairn Islands",
              macroEnFullName: "PITCAIRN ISLANDS GROUP",
              id: 167,
            },
            {
              code: "WSM",
              cnName: "萨摩亚",
              macroEnName: "SAMOA",
              enName: "Samoa",
              macroEnFullName: "INDEPENDENT STATE OF WESTERN SAMOA",
              id: 174,
            },
            {
              code: "CXR",
              cnName: "圣诞岛",
              macroEnName: "CHRISTMAS ISLAND",
              enName: "Christmas Island",
              macroEnFullName: "CHRISTMAS ISLAND",
              id: 181,
            },
            {
              code: "SLB",
              cnName: "所罗门群岛",
              macroEnName: "SOLOMON ISLANDS",
              enName: "Solomon Islands",
              macroEnFullName: "SOLOMON ISLANDS",
              id: 196,
            },
            {
              code: "TON",
              cnName: "汤加",
              macroEnName: "TONGA",
              enName: "Tonga",
              macroEnFullName: "KINGDOM OF TONGA",
              id: 201,
            },
            {
              code: "TUV",
              cnName: "图瓦卢",
              macroEnName: "TUVALU",
              enName: "Tuvalu",
              macroEnFullName: "TUVALU",
              id: 206,
            },
            {
              code: "TKL",
              cnName: "托克劳",
              macroEnName: "TOKELAU",
              enName: "Tokelau",
              macroEnFullName: "TOKELAU",
              id: 209,
            },
            {
              code: "WLF",
              cnName: "瓦利斯和福图纳",
              macroEnName: "WALLIS AND FUTUNA",
              enName: "Wallis and Futuna",
              macroEnFullName: "WALLIS AND FUTUNA ISLANDS",
              id: 210,
            },
            {
              code: "VUT",
              cnName: "瓦努阿图",
              macroEnName: "VANUATU",
              enName: "Vanuatu",
              macroEnFullName: "REPUBLIC OF VANUATU",
              id: 211,
            },
            {
              code: "NCL",
              cnName: "新喀里多尼亚",
              macroEnName: "NEW CALEDONIA",
              enName: "New Caledonia",
              macroEnFullName: "NEW CALEDONIA",
              id: 224,
            },
            {
              code: "NZL",
              cnName: "新西兰",
              macroEnName: "NEW ZEALAND",
              enName: "New Zealand",
              macroEnFullName: "NEW ZEALAND",
              id: 225,
            },
          ],
        },
      ];
      this.setV2CountryList(county);
      this.setV2CurrentPermission(allowPerKey);

      console.log("getPermission -> county", county);
    },

    isMobile() {
      this.isMobilePhone = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },

    collapse() {
      this.changeCollapse();
    },

    changRightStatus(key, val) {
      //有权限
      if (this.allkey[keyMap[key]]) {
        this.showLeft = false;
        this.currentRight = key;
        this.conditions = val; //搜索条件
      }
    },

    changeLeftStatus() {
      this.showLeft = true;
    },

    ...mapMutations([
      "setCollapse",
      "changeCollapse",
      "setV2CurrentPermission",
      "setV2CountryList",
    ]),
  },

  computed: {
    ...mapState({
      collapseStatus(state) {
        return state.Collapse.isCollapse;
      },
      allkey(state) {
        return state.v2Permission.v2CurrentPermission;
      },
      showIndex(state) {
        return state.ShowIndex.show;
      },
      userInfo(state) {
        return state.userInfo;
      },
    }),
  },

  watch: {
    // collapseStatus(newValue) {
    //   if (newValue) {
    //     this.leftWidth = "0%";
    //     this.rightWidth = "100%";
    //   } else {
    //     this.leftWidth = "33%";
    //     this.rightWidth = "66%";
    //   }
    // }
  },
};
</script>

<style scoped>
.full_height {
  position: relative;
}

.route_right {
  height: 100%;
  background: #ffffff;
  border: 0 solid #4e5671;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}
.home-page {
  height: 100%;
  background: #ffffff;
  /* border: 0 solid #4e5671; */
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  position: absolute;
  width: 100%;
  top: 0px;
  overflow: hidden;
  z-index: 20;
}

.full_height {
  transition: all 0.5s;
}
.left {
  position: relative;
}
.collapse_btn {
  position: absolute;
  z-index: 10;
  font-size: 28px;
  color: #7aa4d4;
  cursor: pointer;
  right: -5px;
  top: 50%;
  margin-top: -15px;
  width: 30px;
  height: 30px;
}
</style>
